import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const MESSAGES = {
  en: [
    "Brilla is thinking like a bilingual coach...",
    "Choosing meaningful English and Spanish vocabulary...",
    "Writing teacher language and questions...",
    "Adding DLL support strategies...",
    "Polishing your activity...",
  ],
  es: [
    "Brilla está pensando como entrenadora bilingüe...",
    "Eligiendo vocabulario significativo en inglés y español...",
    "Escribiendo lenguaje del maestro y preguntas...",
    "Agregando estrategias de apoyo para DLL...",
    "Puliendo tu actividad...",
  ],
};

export function GeneratingOverlay({ open, elapsed = 0 }) {
  const { lang } = useLang();
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!open) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES[lang].length), 3000);
    return () => clearInterval(t);
  }, [open, lang]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center p-6" data-testid="generating-overlay">
      <div className="bg-card border border-border rounded-3xl p-10 max-w-sm w-full text-center space-y-5 shadow-lg">
        <div className="relative mx-auto h-16 w-16">
          <span className="absolute inset-0 rounded-2xl border-4 border-primary/25 border-t-secondary animate-spin" />
          <span className="absolute inset-0 flex items-center justify-center"><Sparkles className="h-6 w-6 text-secondary" /></span>
        </div>
        <p className="font-heading font-bold text-lg min-h-[3.5rem] flex items-center justify-center">{MESSAGES[lang][idx]}</p>
        <p className="text-sm text-muted-foreground" aria-live="polite">
          {Math.round(elapsed)}s · {lang === "es" ? "esto suele tardar 30–60 segundos" : "this usually takes 30–60 seconds"}
        </p>
      </div>
    </div>
  );
}
